import { Link } from "react-router-dom";

export const TestLandingPage = () => {
  return (
    <main>
      <div className="flex flex-col gap-x-2">
        <section>
          <ul>
            <li><Link to="/waste?type=bin_bags">Bin bags</Link></li>
            <li><Link to="/waste?type=bins">Bins</Link></li>
            <li><Link to="/waste?type=cardboard_boxes">Cardboard boxes</Link></li>
            <li><Link to="/waste?type=dead_animals">Dead animals</Link></li>
            <li><Link to="/waste?type=dog_poo">Dog poo</Link></li>
            <li><Link to="/waste?type=dumped_rubbish">Dumped rubbish</Link></li>
            <li><Link to="/waste?type=graffiti_posters_and_stickers">Graffiti, posters and stickers</Link></li>
            <li><Link to="/waste?type=litter">Litter</Link></li>
            <li><Link to="/waste?type=street_cleaning">Street cleaning</Link></li>
          </ul>
        </section>
      </div>
    </main>
  );
};
